import { PredefinedRoles } from 'constants/constants';
import { getRole } from 'utility/decode-jwt';

const isOrganizationUser = () => {
  const roles = getRole();
  const userRoles = Array.isArray(roles) ? roles : [roles];
  
  return (
    (userRoles.some(role => role === PredefinedRoles.ORGANIZATION) ||
     userRoles.some(role => role.endsWith('- Administrator'))) &&
    !userRoles.some(role => role === PredefinedRoles.SUPER_ADMINISTRATOR)
  );
};

export default isOrganizationUser;
